import { render, staticRenderFns } from "./DeleteAccountUnableToDelete.vue?vue&type=template&id=0c198a3a&scoped=true"
import script from "./DeleteAccountUnableToDelete.vue?vue&type=script&lang=js"
export * from "./DeleteAccountUnableToDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c198a3a",
  null
  
)

export default component.exports